import useThunkDispatch from 'common/hooks/useThunkDispatch';
import { useEffect } from 'react';
import { updateOrdersForProfile } from '../CartSlice';

function OrderCanceled() {
  const dispatch = useThunkDispatch();

  useEffect(() => {
    dispatch(updateOrdersForProfile());
  }, [dispatch]);

  return (
    <>
      <h1>Order Canceled</h1>
      <h3>
        Your order has been canceled. You may check out with these registration
        numbers again.
      </h3>
    </>
  );
}

export default OrderCanceled;
